<template>
  <span class="handle">
    <span class="drag left"></span>
    <span>{{label}}</span>
    <div class="switch small">
      <input class="switch-input" :id="id" :name="name" type="checkbox" :checked="checked === trueValue" :disabled="disabled" @change="onChange">

      <label class="switch-paddle" :for="id">
        <span class="switch-active" aria-hidden="false">{{labelTrue}}</span>
        <span class="switch-inactive" aria-hidden="true">{{labelFalse}}</span>
      </label>
    </div>
  </span>
</template>

<script>
export default {
  name: 'TheSwitchInputPopoverDragable',
  inject: [
    '$validator'
  ],
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    labelTrue: {
      type: [String, Boolean, Number],
      default: 'Ja'
    },
    labelFalse: {
      type: [String, Boolean, Number],
      default: 'Nei'
    },
    trueValue: {
      type: [String, Boolean, Number],
      default: true
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: false
    },
    id: {
      type: String,
      default: function () {
        return 'switch-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    modelValue: {
      default: undefined
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    model: {}
  },
  data () {
    return {
      checked: false
    }
  },
  mounted () {
    // Init checked
    this.checked = this.modelValue === this.trueValue ? this.trueValue : this.falseValue
  },
  methods: {
    onChange (e) {
      if (!e.target.checked) {
        this.checked = this.falseValue
      } else {
        this.checked = this.trueValue
      }

      this.$emit('input', this.checked)
    },
    toggle () {
      if (this.disabled) {
        return
      }

      if (this.checked === this.trueValue) {
        this.checked = this.falseValue
      } else {
        this.checked = this.trueValue
      }

      this.$emit('input', this.checked)
    }
  },
  watch: {
    modelValue (newValue) {
      // If model value is changed from outside
      this.checked = newValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheSwitchInputPopoverDragable.vue